<template>
  <div class="h-full bg-[#f8fafc] p-4 overflow-y-auto custom-scroll">
    <!-- Reports Card -->
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 border-t-4 border-t-[#0d4169] transition-all overflow-hidden mb-6">
      <div class="px-6 pt-5 pb-3 flex items-center justify-between gap-4">
        <h2 class="text-base font-bold text-[#0d4169]">Void & Audit Report</h2>
        <div class="flex items-center gap-1 rounded-lg bg-slate-100 p-1">
          <button type="button" @click="switchReportTab('normal')" :class="reportTab === 'normal' ? 'bg-white text-[#0d4169] shadow-sm' : 'text-slate-500 hover:text-slate-700'" class="px-3 py-1.5 rounded-md text-xs font-bold transition-colors">Normal Order</button>
          <button type="button" @click="switchReportTab('special')" :class="reportTab === 'special' ? 'bg-white text-[#0d4169] shadow-sm' : 'text-slate-500 hover:text-slate-700'" class="px-3 py-1.5 rounded-md text-xs font-bold transition-colors">Special Order</button>
        </div>
      </div>

      <form @submit.prevent="generateReport(1)" class="px-6 pb-6 pt-2 border-b border-slate-100">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-3">
          <!-- Start Date -->
          <div class="flex flex-col gap-1 text-left">
            <label class="text-[0.78rem] font-semibold text-[#1e293b]">Start Date <span class="text-red-500">*</span></label>
            <input
              v-model="filters.startDate"
              required
              type="date"
              class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
            />
          </div>

          <!-- End Date -->
          <div class="flex flex-col gap-1 text-left">
            <label class="text-[0.78rem] font-semibold text-[#1e293b]">End Date</label>
            <input
              v-model="filters.endDate"
              type="date"
              class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
            />
          </div>

          <!-- By Department -->
          <div class="flex flex-col gap-1 text-left">
            <label class="text-[0.78rem] font-semibold text-[#1e293b]">By Department</label>
            <select
              v-model="filters.departmentId"
              class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer hover:bg-slate-50"
            >
              <option :value="null">All Departments</option>
              <option v-for="d in departments" :key="d.id" :value="d.id">{{ d.name }}</option>
            </select>
          </div>

          <!-- By Sub Department -->
          <div class="flex flex-col gap-1 text-left">
            <label class="text-[0.78rem] font-semibold text-[#1e293b]">By Sub Department</label>
            <select
              v-model="filters.subDepartmentId"
              :disabled="!filters.departmentId"
              class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer disabled:opacity-50 hover:bg-slate-50"
            >
              <option :value="null">All Sub Depts</option>
              <option v-for="sd in subDepartments" :key="sd.id" :value="sd.id">{{ sd.name }}</option>
            </select>
          </div>

          <!-- Created By (Waiter) -->
          <div class="flex flex-col gap-1 text-left">
            <label class="text-[0.78rem] font-semibold text-[#1e293b]">Created By (Waiter)</label>
            <select
              v-model="filters.waiterId"
              class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer hover:bg-slate-50"
            >
              <option :value="null">All Users</option>
              <option v-for="u in allUsers" :key="u.id" :value="u.id">{{ u.full_name || u.username }}</option>
            </select>
          </div>

          <!-- Performed By (Admin) -->
          <div class="flex flex-col gap-1 text-left">
            <label class="text-[0.78rem] font-semibold text-[#1e293b]">Void By</label>
            <select
              v-model="filters.adminId"
              class="px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer hover:bg-slate-50"
            >
              <option :value="null">All Users</option>
              <option v-for="u in allUsers" :key="u.id" :value="u.id">{{ u.full_name || u.username }}</option>
            </select>
          </div>

          <!-- Menu Name Search + Unseen Voids chip -->
          <div  class="flex flex-col gap-1 text-left">
            <label class="text-[0.78rem] font-semibold text-[#1e293b]">Menu Name Search</label>
            <div class="flex flex-col sm:flex-row sm:items-center gap-2">
              <input
                v-model="filters.menuName"
                type="text"
                placeholder="Search by item name..."
                class="flex-1 px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm"
              />
            
            </div>
          </div>
          <div  class="flex w-full justify-end self-start sm:col-span-2 lg:col-span-1 lg:col-start-4">
           
           
             
              <span v-if="reportTab === 'normal' && unseenVoidsCount > 0"
                role="button"
                tabindex="0"
                class="mt-5 px-2.5 py-1 rounded-full text-[10px] font-bold whitespace-nowrap bg-rose-100 text-rose-700 border border-rose-300 cursor-pointer hover:bg-rose-200 transition-colors self-start sm:self-auto shrink-0"
                title="Click to view unseen void logs"
                @click="openUnseenVoidsModal"
                @keydown.enter="openUnseenVoidsModal"
              >
                Unseen Voids: {{ unseenVoidsCount }}
              </span>
           
          </div>
        </div>

        <div class="mt-6 flex justify-end items-center gap-4">
          <div v-if="loading" class="text-xs text-[#0d4169] flex items-center gap-2 font-medium">
            <span class="w-4 h-4 border-2 border-[#0d4169] border-t-transparent rounded-full animate-spin"></span>
            Processing...
          </div>
          <button
            type="button"
            @click="handlePrintReport"
            class="px-4 py-1.5 bg-slate-200 text-slate-700 text-sm font-bold rounded-md shadow-md hover:bg-slate-300 transition-all active:scale-95 disabled:opacity-60 flex items-center gap-2"
            :disabled="!canPrintReport"
            title="Print is available after the report is generated"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M6 9V2h12v7"/>
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
              <rect x="6" y="14" width="12" height="8"/>
            </svg>
            <span>Print</span>
          </button>
          <button
            type="submit"
            class="px-8 py-2 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:scale-95 disabled:opacity-60 flex items-center gap-2"
            :disabled="loading || !filters.startDate"
          >
            <span>Generate Report</span>
          </button>
        </div>
      </form>

      <!-- Results Table Section -->
      <div class="relative overflow-x-auto min-h-[400px] px-3 font-['Segoe_UI']">
        <table class="w-full border-collapse bg-white">
          <thead class="sticky top-0 z-10 bg-[#f8fafc] shadow-sm">
            <tr>
              <th class="px-4 py-3 text-left font-bold text-[#64748b] border-b text-[11px]">No</th>
              <th class="px-4 py-3 text-left font-bold text-[#64748b] border-b text-[11px]">Order Date</th>
              <th class="px-4 py-3 text-left font-bold text-[#64748b] border-b text-[11px]">Void Date</th>
              <th class="px-4 py-3 text-left font-bold text-[#64748b] border-b text-[11px]">Created By</th>
              <th class="px-4 py-3 text-left font-bold text-[#64748b] border-b text-[11px]">Performed By</th>
              <th class="px-4 py-3 text-left font-bold text-[#64748b] border-b text-[11px]">Dept</th>
              <th class="px-4 py-3 text-left font-bold text-[#64748b] border-b text-[11px]">Sub Dept</th>
              <th class="px-4 py-3 text-left font-bold text-[#64748b] border-b text-[11px]">Menu Name</th>
              <th class="px-4 py-3 text-center font-bold text-[#64748b] border-b text-[11px]">Action</th>
              <th class="px-4 py-3 text-center font-bold text-[#64748b] border-b text-[11px]">Qty</th>
              <th class="px-4 py-3 text-right font-bold text-[#64748b] border-b text-[11px]">Unit Price</th>
              <th class="px-4 py-3 text-right font-bold text-[#64748b] border-b text-[11px]">Total Price</th>
              <th class="px-4 py-3 text-center font-bold text-[#64748b] border-b text-[11px]">Status</th>
              <!-- <th class="px-4 py-3 text-center font-bold text-[#64748b] border-b text-[11px]">New</th> -->
            </tr>
          </thead>

          <tbody>
            <tr v-if="rows.length === 0">
              <td colspan="14" class="px-4 py-32 text-center text-slate-400 italic text-sm">
                <div class="text-5xl mb-4 opacity-20">📄</div>
                No audit logs found for the selected criteria.<br/>
                Adjust filters and click <span class="text-[#0d4169] font-bold">"Generate Report"</span>
              </td>
            </tr>
            <tr v-for="(row, index) in rows" :key="index" class="border-b last:border-0 hover:bg-slate-50 transition-colors group">
              <td class="px-4 py-3 text-slate-500 text-xs">{{ ((pagination.page - 1) * pagination.limit) + index + 1 }}</td>
              <td class="px-4 py-3 text-left text-slate-600 text-[11px]">
                {{ formatFullDateTime(row.orderDateTime) }}
              </td>
              <td class="px-4 py-3 text-left font-bold text-slate-700 text-[11px]">
                {{ formatFullDateTime(row.voidDateTime) }}
              </td>
              <td class="px-4 py-3 text-left font-medium text-slate-500 text-[11px]">{{ row.createdBy }}</td>
              <td class="px-4 py-3 text-left font-bold text-slate-700 text-[11px]">{{ row.performedBy }}</td>
              <td class="px-4 py-3 text-left text-slate-500 text-[11px]">{{ row.department }}</td>
              <td class="px-4 py-3 text-left text-slate-500 text-[11px]">{{ row.subDepartment }}</td>
              <td class="px-4 py-3 text-left font-semibold text-[#0d4169] text-[11px]">
                {{ row.menuName }}
              </td>
              <td class="px-4 py-3 text-center">
                <span :class="[
                  'px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-tighter',
                  row.action === 'DELETE_ITEM' ? 'bg-red-100 text-red-700' :
                  row.action === 'DELETE_GROUP' ? 'bg-orange-100 text-orange-700' :
                  'bg-blue-100 text-blue-700'
                ]">
                  {{ row.action.replace('_', ' ') }}
                </span>
              </td>
              <td class="px-4 py-3 text-center font-bold text-slate-400 text-[11px]">{{ row.originalQty-row.newQty }}</td>
              <td class="px-4 py-3 text-right text-slate-600 text-[11px]">{{ formatCurrency(row.unitPrice) }}</td>
              <td class="px-4 py-3 text-right font-bold text-[#0d4169] text-[11px]">{{ formatCurrency(row.totalPrice) }}</td>
              <td class="px-4 py-3 text-center text-[11px] font-semibold" :class="(Number(row.notPrintedCount) || 0) === 0 ? 'text-emerald-600' : 'text-amber-600'">
                {{ (Number(row.notPrintedCount) || 0) === 0 ? 'Printed' : 'Not Printed' }}
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="unseenOrderLogIds.length > 0" class="px-4 py-4 text-center border-t border-slate-100">
          <button
            type="button"
            @click="markAsSeen"
            :disabled="markingSeen"
            class="px-6 py-1.5 bg-emerald-600 text-white text-sm font-bold rounded-md shadow-sm hover:bg-emerald-700 transition-all active:scale-95 disabled:opacity-60"
          >
            {{ markingSeen ? 'Saving...' : 'Seen' }}
          </button>
        </div>
      </div>

      <!-- Pagination Controls -->
      <div v-if="pagination.totalPages > 1" class="mt-6 flex flex-wrap items-center justify-center gap-2 pb-10">
          <button 
            @click="generateReport(1)" 
            :disabled="pagination.page === 1"
            class="w-10 h-10 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 transition-all disabled:opacity-40 disabled:cursor-not-allowed font-bold"
          >
            «
          </button>
          <button 
            @click="generateReport(pagination.page - 1)" 
            :disabled="pagination.page === 1"
            class="px-4 h-10 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 transition-all disabled:opacity-40 disabled:cursor-not-allowed text-sm font-bold"
          >
            Prev
          </button>

          <div class="flex items-center gap-1">
            <button 
              v-for="p in pagination.totalPages" 
              :key="p"
              @click="generateReport(p)"
              :class="[
                'w-10 h-10 flex items-center justify-center rounded-lg border transition-all text-sm font-bold',
                pagination.page === p ? 'bg-[#0d4169] text-white border-[#0d4169] shadow-lg scale-110' : 'bg-white text-slate-600 border-slate-200 hover:border-[#0d4169] hover:text-[#0d4169]'
              ]"
            >
              {{ p }}
            </button>
          </div>

          <button 
            @click="generateReport(pagination.page + 1)" 
            :disabled="pagination.page === pagination.totalPages"
            class="px-4 h-10 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 transition-all disabled:opacity-40 disabled:cursor-not-allowed text-sm font-bold"
          >
            Next
          </button>
          <button 
            @click="generateReport(pagination.totalPages)" 
            :disabled="pagination.page === pagination.totalPages"
            class="w-10 h-10 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 transition-all disabled:opacity-40 disabled:cursor-not-allowed font-bold"
          >
            »
          </button>
      </div>
    </div>

    <!-- Unseen Voids Modal -->
    <div
      v-if="showUnseenVoidsModal"
      class="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4"
      @click.self="closeUnseenVoidsModal"
    >
      <div class="bg-white rounded-xl shadow-xl border border-[#0d4169] w-full max-w-6xl max-h-[90vh] flex flex-col overflow-hidden">
        <div class="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-[#0d4169] text-white">
          <h3 class="text-base font-bold">Unseen Voids</h3>
          <button
            type="button"
            @click="closeUnseenVoidsModal"
            class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 text-white text-lg leading-none"
          >
            &times;
          </button>
        </div>

        <div class="flex-1 overflow-auto px-4 py-4">
          <div v-if="loadingUnseenList" class="py-16 text-center text-sm text-[#0d4169]">
            <span class="inline-block w-5 h-5 border-2 border-[#0d4169] border-t-transparent rounded-full animate-spin mr-2 align-middle"></span>
            Loading void logs...
          </div>
          <div v-else-if="unseenVoidsList.length === 0" class="py-16 text-center text-slate-400 italic text-sm">
            No unseen void logs found.
          </div>
          <div v-else class="overflow-x-auto">
            <table class="w-full border-collapse bg-white">
              <thead class="sticky top-0 z-10 bg-[#f8fafc]">
                <tr>
                  <th class="px-3 py-2 text-left font-bold text-[#64748b] border-b text-[11px]">No</th>
                  <th class="px-3 py-2 text-left font-bold text-[#64748b] border-b text-[11px]">Order Date</th>
                  <th class="px-3 py-2 text-left font-bold text-[#64748b] border-b text-[11px]">Void Date</th>
                  <th class="px-3 py-2 text-left font-bold text-[#64748b] border-b text-[11px]">Created By</th>
                  <th class="px-3 py-2 text-left font-bold text-[#64748b] border-b text-[11px]">Performed By</th>
                  <th class="px-3 py-2 text-left font-bold text-[#64748b] border-b text-[11px]">Dept</th>
                  <th class="px-3 py-2 text-left font-bold text-[#64748b] border-b text-[11px]">Sub Dept</th>
                  <th class="px-3 py-2 text-left font-bold text-[#64748b] border-b text-[11px]">Menu Name</th>
                  <th class="px-3 py-2 text-center font-bold text-[#64748b] border-b text-[11px]">Action</th>
                  <th class="px-3 py-2 text-center font-bold text-[#64748b] border-b text-[11px]">Qty</th>
                  <th class="px-3 py-2 text-right font-bold text-[#64748b] border-b text-[11px]">Unit Price</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in unseenVoidsList"
                  :key="row.id"
                  class="border-b last:border-0 hover:bg-slate-50 transition-colors"
                >
                  <td class="px-3 py-2 text-slate-500 text-[11px]">{{ row.no }}</td>
                  <td class="px-3 py-2 text-slate-600 text-[11px]">{{ formatFullDateTime(row.orderDateTime) }}</td>
                  <td class="px-3 py-2 text-slate-600 text-[11px]">{{ formatFullDateTime(row.voidDateTime) }}</td>
                  <td class="px-3 py-2 text-slate-600 text-[11px]">{{ row.createdBy }}</td>
                  <td class="px-3 py-2 text-slate-600 text-[11px]">{{ row.performedBy }}</td>
                  <td class="px-3 py-2 text-slate-600 text-[11px]">{{ row.department }}</td>
                  <td class="px-3 py-2 text-slate-600 text-[11px]">{{ row.subDepartment }}</td>
                  <td class="px-3 py-2 font-semibold text-[#0d4169] text-[11px]">{{ row.menuName }}</td>
                  <td class="px-3 py-2 text-center">
                    <span :class="[
                      'px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-tighter',
                      row.action === 'DELETE_ITEM' ? 'bg-red-100 text-red-700' :
                      row.action === 'DELETE_GROUP' ? 'bg-orange-100 text-orange-700' :
                      'bg-blue-100 text-blue-700'
                    ]">
                      {{ row.action.replace('_', ' ') }}
                    </span>
                  </td>
                  <td class="px-3 py-2 text-center font-bold text-slate-600 text-[11px]">{{ row.originalQty - row.newQty }}</td>
                  <td class="px-3 py-2 text-right text-slate-600 text-[11px]">{{ formatCurrency(row.unitPrice) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="px-6 py-3 border-t border-slate-100 flex justify-end">
          <button
            type="button"
            @click="closeUnseenVoidsModal"
            class="px-6 py-2 bg-[#0d4169] text-white text-sm font-bold rounded-md hover:bg-[#0a3354] transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
import store from '../../store'
import { apiFetch } from '../../utils/api'

const currentUser = computed(() => store.getters.currentUser)
const companyId = computed(() => currentUser.value?.companyId || currentUser.value?.company_id || currentUser.value?.company?.id || null)
const branchId = computed(() => currentUser.value?.branchId || currentUser.value?.branch_id || currentUser.value?.branch?.id || null)

const printCompanyName = computed(() =>
  currentUser.value?.company?.name ||
  currentUser.value?.companyName ||
  currentUser.value?.company_name ||
  'Company'
)

const printCompanyLogo = computed(() =>
  currentUser.value?.company?.logo_url ||
  currentUser.value?.companyLogo ||
  currentUser.value?.company_logo ||
  ''
)

const loading = ref(false)
const reportTab = ref('normal')
const markingSeen = ref(false)
const rows = ref([])
const unseenOrderLogIds = ref([])
const unseenVoidsCount = ref(0)
const showUnseenVoidsModal = ref(false)
const loadingUnseenList = ref(false)
const unseenVoidsList = ref([])

const pagination = ref({
  page: 1,
  limit: 15,
  totalCount: 0,
  totalPages: 0
})

const filters = ref({
  startDate: '',
  endDate: '',
  departmentId: null,
  subDepartmentId: null,
  waiterId: null,
  adminId: null,
  menuName: ''
})

const canPrintReport = computed(() =>
  !loading.value &&
  !!filters.value.startDate &&
  rows.value.length > 0
)

// Data for dropdowns
const departments = ref([])
const subDepartments = ref([])
const waiters = ref([])
const cashiers = ref([])
const allUsers = ref([])

function toLocalISODate(date = new Date()) {
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

function formatFullDateTime(dateStr) {
  if (!dateStr) return '---'
  const date = new Date(dateStr)
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  const hh = String(date.getHours()).padStart(2, '0')
  const mm = String(date.getMinutes()).padStart(2, '0')
  const ss = String(date.getSeconds()).padStart(2, '0')
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
}

function formatCurrency(value) {
  if (value === undefined || value === null) return '0.00'
  return parseFloat(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

function formatDateForDisplay(isoDate) {
  const s = String(isoDate || '')
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!m) return s
  return `${m[3]}/${m[2]}/${m[1]}`
}

function getReportDateRangeLabel() {
  const from = filters.value.startDate
  if (!from) return '-'
  const fromLabel = formatDateForDisplay(from)
  const to = filters.value.endDate
  return to ? `${fromLabel} - ${formatDateForDisplay(to)}` : fromLabel
}

function getImageFormatFromDataUrl(dataUrl) {
  if (!dataUrl || typeof dataUrl !== 'string') return 'PNG'
  if (dataUrl.startsWith('data:image/jpeg') || dataUrl.startsWith('data:image/jpg')) return 'JPEG'
  if (dataUrl.startsWith('data:image/webp')) return 'WEBP'
  return 'PNG'
}

async function imageUrlToDataUrl(url) {
  if (!url) return { dataUrl: null, format: 'PNG' }
  try {
    const res = await fetch(url)
    if (!res.ok) return { dataUrl: null, format: 'PNG' }
    const blob = await res.blob()
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
    return {
      dataUrl,
      format: getImageFormatFromDataUrl(dataUrl)
    }
  } catch {
    return { dataUrl: null, format: 'PNG' }
  }
}

function buildVoidReportQueryParams(pageNumber = 1, limit = pagination.value.limit) {
  const queryParams = {
    ...filters.value,
    page: pageNumber,
    limit,
    companyId: companyId.value,
    branchId: branchId.value
  }

  Object.keys(queryParams).forEach(key => {
    if (queryParams[key] === null || queryParams[key] === '' || queryParams[key] === 'All') {
      delete queryParams[key]
    }
  })

  return new URLSearchParams(queryParams).toString()
}

function getReportEndpoint() {
  return reportTab.value === 'special' ? '/special-orders/void-report' : '/orders/void-report'
}

function switchReportTab(tab) {
  reportTab.value = tab
  rows.value = []
  pagination.value = { ...pagination.value, page: 1, totalCount: 0, totalPages: 0 }
  unseenOrderLogIds.value = []
}

async function fetchAllVoidRowsForPrint() {
  const totalCount = Number(pagination.value.totalCount || 0)
  const limit = totalCount > 0 ? totalCount : 999999
  const queryString = buildVoidReportQueryParams(1, limit)
  const res = await apiFetch(`${getReportEndpoint()}?${queryString}`)
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.message || 'Failed to load report data for print')
  }
  const data = await res.json()
  return Array.isArray(data.rows) ? data.rows : []
}

async function generateVoidReportPdf() {
  const printRows = await fetchAllVoidRowsForPrint()
  if (!printRows.length) return

  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'landscape' })
  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()
  const leftMargin = 10
  const rightMargin = 8
  const topMargin = 8
  const headerBottomY = 28
  const totalPagesExp = '{total_pages_count_string}'
  const printDateLabel = getReportDateRangeLabel()
  const { dataUrl: logoDataUrl, format: logoFormat } = await imageUrlToDataUrl(String(printCompanyLogo.value || '').trim())

  let grandTotal = 0
  const tableBody = printRows.map((row, idx) => {
    const qty = Number(row.originalQty || 0) - Number(row.newQty || 0)
    const totalPrice = Number(row.totalPrice || 0)
    grandTotal += totalPrice
    return [
      String(idx + 1),
      formatFullDateTime(row.orderDateTime),
      formatFullDateTime(row.voidDateTime),
      row.createdBy || '-',
      row.performedBy || '-',
      row.department || '-',
      row.subDepartment || '-',
      row.menuName || '-',
      String(row.action || '').replace('_', ' '),
      String(qty),
      Number(row.unitPrice || 0).toFixed(2),
      totalPrice.toFixed(2)
    ]
  })

  autoTable(doc, {
    head: [[
      '#', 'Order Date', 'Void Date', 'Created By', 'Performed By', 'Dept',
      'Sub Dept', 'Menu Name', 'Action', 'Qty', 'Unit Price', 'Total Price'
    ]],
    body: tableBody,
    startY: headerBottomY + 2,
    theme: 'grid',
    margin: { left: leftMargin, right: rightMargin, top: headerBottomY + 2, bottom: 12 },
    styles: {
      fontSize: 7,
      cellPadding: 0.9,
      textColor: [0, 0, 0],
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      overflow: 'linebreak'
    },
    headStyles: {
      fillColor: [243, 244, 246],
      textColor: [0, 0, 0],
      fontStyle: 'bold'
    },
    bodyStyles: {
      fillColor: [255, 255, 255]
    },
    alternateRowStyles: {
      fillColor: [255, 255, 255]
    },
    didDrawPage: () => {
      if (logoDataUrl) {
        doc.addImage(logoDataUrl, logoFormat, leftMargin, topMargin, 14, 10, undefined, 'FAST')
      }
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(10)
      doc.text(String(printCompanyName.value || 'Company'), pageWidth / 2, topMargin + 3, { align: 'center' })
      doc.setFontSize(11)
      doc.text('Void & Audit Report', pageWidth / 2, topMargin + 8, { align: 'center' })

      doc.setFont('helvetica', 'bold')
      doc.setFontSize(8)
      doc.text(`Date: ${printDateLabel}`, pageWidth - rightMargin, topMargin + 6, { align: 'right' })

      doc.setDrawColor(0, 0, 0)
      doc.setLineWidth(0.2)
      doc.line(leftMargin, headerBottomY, pageWidth - rightMargin, headerBottomY)

      const pageNo = doc.getNumberOfPages()
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(8)
      doc.text(`Page ${pageNo} of ${totalPagesExp}`, pageWidth - rightMargin, pageHeight - 5, { align: 'right' })
    }
  })

  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp)
  }

  const finalY = (doc.lastAutoTable?.finalY || (headerBottomY + 2)) + 8
  const valueX = pageWidth - rightMargin
  const labelX = valueX - 40
  const lineGap = 6
  let totalsY = finalY

  doc.setLineWidth(0.2)
  doc.line(labelX - 18, totalsY - (lineGap * 0.5), valueX, totalsY - (lineGap * 0.5))
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(10)
  doc.text('Grand total:', labelX, totalsY, { align: 'right' })
  doc.text(Number(grandTotal || 0).toFixed(2), valueX, totalsY, { align: 'right' })

  const footerY = Math.max(totalsY + (lineGap * 4), pageHeight - 28)
  const firstX = leftMargin + 10
  const secondX = pageWidth / 2 - 20
  const thirdX = pageWidth - rightMargin - 56
  const lineW = 40

  doc.setFont('helvetica', 'normal')
  doc.line(firstX, footerY, firstX + lineW, footerY)
  doc.text('Requested By', firstX + (lineW / 2), footerY + 5, { align: 'center' })
  doc.line(secondX, footerY, secondX + lineW, footerY)
  doc.text('Checked By', secondX + (lineW / 2), footerY + 5, { align: 'center' })
  doc.line(thirdX, footerY, thirdX + lineW, footerY)
  doc.text('Approved By', thirdX + (lineW / 2), footerY + 5, { align: 'center' })

  const safeDate = String(new Date().toISOString().slice(0, 10)).replace(/[\\/:*?"<>|]/g, '-').trim()
  doc.save(`Void-Audit-Report-${safeDate}.pdf`)
}

async function handlePrintReport() {
  if (!canPrintReport.value) return
  if (!confirm('Are you sure..........Print?')) return
  try {
    await generateVoidReportPdf()
  } catch (error) {
    console.error('Print void report error:', error)
    alert(error.message || 'Failed to print report')
  }
}

async function loadFilterData() {
  if (!companyId.value) return
  try {
    const [deptRes, usersRes] = await Promise.all([
      branchId.value ? apiFetch(`/departments/branch/${branchId.value}`) : apiFetch(`/departments/company/${companyId.value}`),
      branchId.value ? apiFetch(`/users/branch/${branchId.value}`) : apiFetch(`/users/company/${companyId.value}`)
    ])

    if (deptRes.ok) departments.value = await deptRes.json()
    if (usersRes.ok) {
      allUsers.value = await usersRes.json()
      waiters.value = allUsers.value.filter(u => u.role?.toLowerCase().includes('waiter'))
      cashiers.value = allUsers.value.filter(u => 
        ['cashier', 'admin', 'superadmin', 'manager'].some(r => u.role?.toLowerCase().includes(r))
      )
      allUsers.value.sort((a, b) =>
  a.full_name.localeCompare(b.full_name)
)
    }
  } catch (err) {
    console.error('Failed to load filter data', err)
  }
}

async function loadSubDepartments() {
  if (!filters.value.departmentId) {
    subDepartments.value = []
    return
  }
  try {
    const res = await apiFetch(`/sub-departments/department/${filters.value.departmentId}`)
    if (res.ok) subDepartments.value = await res.json()
  } catch (err) {
    console.error('Failed to load sub-departments', err)
  }
}

watch(() => filters.value.departmentId, () => {
  filters.value.subDepartmentId = null
  loadSubDepartments()
})

watch(() => companyId.value, (newVal) => {
  if (newVal) {
    loadFilterData()
    loadUnseenVoidsCount()
  }
}, { immediate: true })

watch(branchId, () => {
  loadUnseenVoidsCount()
})

async function generateReport(pageNumber = 1) {
  if (!filters.value.startDate) {
    alert('Start date is required')
    return
  }
  loading.value = true
  try {
    const queryString = buildVoidReportQueryParams(pageNumber, pagination.value.limit)
    const res = await apiFetch(`${getReportEndpoint()}?${queryString}`)
    if (res.ok) {
      const data = await res.json()
      rows.value = data.rows
      unseenOrderLogIds.value = Array.isArray(data.unseenOrderLogIds) ? data.unseenOrderLogIds : []
      pagination.value = {
        ...pagination.value,
        page: data.page,
        totalPages: data.totalPages,
        totalCount: data.totalCount
      }
    } else {
      unseenOrderLogIds.value = []
      const err = await res.json()
      alert(err.message || 'Failed to generate report')
    }
  } catch (err) {
    console.error('Report generation failed', err)
    unseenOrderLogIds.value = []
    alert('An error occurred while generating the report')
  } finally {
    loading.value = false
  }
}

async function markAsSeen() {
  if (!unseenOrderLogIds.value.length) return

  markingSeen.value = true
  try {
    const params = new URLSearchParams()
    if (companyId.value) params.set('companyId', companyId.value)
    if (branchId.value) params.set('branchId', branchId.value)

    const res = await apiFetch(`/orders/mark-logs-seen?${params.toString()}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderLogIds: unseenOrderLogIds.value })
    })

    if (res.ok) {
      unseenOrderLogIds.value = []
      await loadUnseenVoidsCount()
    } else {
      const err = await res.json()
      alert(err.message || 'Failed to mark logs as seen')
    }
  } catch (err) {
    console.error('Mark logs seen error:', err)
    alert('An error occurred while marking logs as seen')
  } finally {
    markingSeen.value = false
  }
}

function buildUnseenVoidsQueryParams() {
  const params = new URLSearchParams()
  if (companyId.value) params.set('companyId', companyId.value)
  if (branchId.value) params.set('branchId', branchId.value)
  return params
}

async function loadUnseenVoidsCount() {
  if (!companyId.value && !branchId.value) {
    unseenVoidsCount.value = 0
    return
  }
  try {
    const res = await apiFetch(`/orders/unseen-voids-count?${buildUnseenVoidsQueryParams().toString()}`)
    if (res.ok) {
      const data = await res.json()
      unseenVoidsCount.value = Number(data.count) || 0
    }
  } catch (err) {
    console.error('Failed to load unseen voids count', err)
  }
}

async function openUnseenVoidsModal() {
  if (!companyId.value && !branchId.value) return

  showUnseenVoidsModal.value = true
  loadingUnseenList.value = true
  unseenVoidsList.value = []

  try {
    const res = await apiFetch(`/orders/unseen-voids-list?${buildUnseenVoidsQueryParams().toString()}`)
    if (res.ok) {
      const data = await res.json()
      unseenVoidsList.value = Array.isArray(data.rows) ? data.rows : []
    } else {
      const err = await res.json()
      alert(err.message || 'Failed to load unseen void logs')
      showUnseenVoidsModal.value = false
    }
  } catch (err) {
    console.error('Failed to load unseen voids list', err)
    alert('An error occurred while loading unseen void logs')
    showUnseenVoidsModal.value = false
  } finally {
    loadingUnseenList.value = false
  }
}

function closeUnseenVoidsModal() {
  showUnseenVoidsModal.value = false
  unseenVoidsList.value = []
}

onMounted(() => {
  filters.value.startDate = toLocalISODate()
  loadUnseenVoidsCount()
})
</script>

<style scoped>
table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 12px;
  line-height: 1.2;
  color: #1e293b;
}

th, td {
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  padding: 8px 12px;
}

th {
  background: #f8fafc;
  cursor: default;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.025em;
}

select, input {
  font-family: inherit;
}

.custom-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
